"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _construct = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeTypeError = exports.HtmlElementTypeError = void 0;
exports.checkHtmlElement = checkHtmlElement;
exports.checkNode = checkNode;
exports.compareArraysAsSet = compareArraysAsSet;
exports.deprecate = deprecate;
exports.getMessage = getMessage;
exports.getSingleElementValue = getSingleElementValue;
exports.getTag = getTag;
exports.matches = matches;
exports.normalize = normalize;
exports.parseCSS = parseCSS;
exports.toSentence = toSentence;

var _redent = _interopRequireDefault(require("redent"));

var _parse = _interopRequireDefault(require("css/lib/parse"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var GenericTypeError = /*#__PURE__*/function (_Error) {
  _inherits(GenericTypeError, _Error);

  var _super = _createSuper(GenericTypeError);

  function GenericTypeError(expectedString, received, matcherFn, context) {
    var _this;

    _classCallCheck(this, GenericTypeError);

    _this = _super.call(this);
    /* istanbul ignore next */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), matcherFn);
    }

    var withType = '';

    try {
      withType = context.utils.printWithType('Received', received, context.utils.printReceived);
    } catch (e) {// Can throw for Document:
      // https://github.com/jsdom/jsdom/issues/2304
    }

    _this.message = [context.utils.matcherHint("".concat(context.isNot ? '.not' : '', ".").concat(matcherFn.name), 'received', ''), '', // eslint-disable-next-line @babel/new-cap
    "".concat(context.utils.RECEIVED_COLOR('received'), " value must ").concat(expectedString, "."), withType].join('\n');
    return _this;
  }

  return _createClass(GenericTypeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var HtmlElementTypeError = /*#__PURE__*/function (_GenericTypeError) {
  _inherits(HtmlElementTypeError, _GenericTypeError);

  var _super2 = _createSuper(HtmlElementTypeError);

  function HtmlElementTypeError() {
    _classCallCheck(this, HtmlElementTypeError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super2.call.apply(_super2, [this, 'be an HTMLElement or an SVGElement'].concat(args));
  }

  return _createClass(HtmlElementTypeError);
}(GenericTypeError);

exports.HtmlElementTypeError = HtmlElementTypeError;

var NodeTypeError = /*#__PURE__*/function (_GenericTypeError2) {
  _inherits(NodeTypeError, _GenericTypeError2);

  var _super3 = _createSuper(NodeTypeError);

  function NodeTypeError() {
    _classCallCheck(this, NodeTypeError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _super3.call.apply(_super3, [this, 'be a Node'].concat(args));
  }

  return _createClass(NodeTypeError);
}(GenericTypeError);

exports.NodeTypeError = NodeTypeError;

function checkHasWindow(htmlElement, ErrorClass) {
  if (!htmlElement || !htmlElement.ownerDocument || !htmlElement.ownerDocument.defaultView) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    throw _construct(ErrorClass, [htmlElement].concat(args));
  }
}

function checkNode(node) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  checkHasWindow.apply(void 0, [node, NodeTypeError].concat(args));
  var window = node.ownerDocument.defaultView;

  if (!(node instanceof window.Node)) {
    throw _construct(NodeTypeError, [node].concat(args));
  }
}

function checkHtmlElement(htmlElement) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  checkHasWindow.apply(void 0, [htmlElement, HtmlElementTypeError].concat(args));
  var window = htmlElement.ownerDocument.defaultView;

  if (!(htmlElement instanceof window.HTMLElement) && !(htmlElement instanceof window.SVGElement)) {
    throw _construct(HtmlElementTypeError, [htmlElement].concat(args));
  }
}

var InvalidCSSError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidCSSError, _Error2);

  var _super4 = _createSuper(InvalidCSSError);

  function InvalidCSSError(received, matcherFn, context) {
    var _this2;

    _classCallCheck(this, InvalidCSSError);

    _this2 = _super4.call(this);
    /* istanbul ignore next */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this2), matcherFn);
    }

    _this2.message = [received.message, '', // eslint-disable-next-line @babel/new-cap
    context.utils.RECEIVED_COLOR("Failing css:"), // eslint-disable-next-line @babel/new-cap
    context.utils.RECEIVED_COLOR("".concat(received.css))].join('\n');
    return _this2;
  }

  return _createClass(InvalidCSSError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function parseCSS(css) {
  var ast = (0, _parse.default)("selector { ".concat(css, " }"), {
    silent: true
  }).stylesheet;

  if (ast.parsingErrors && ast.parsingErrors.length > 0) {
    var _ast$parsingErrors$ = ast.parsingErrors[0],
        reason = _ast$parsingErrors$.reason,
        line = _ast$parsingErrors$.line;

    for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }

    throw _construct(InvalidCSSError, [{
      css: css,
      message: "Syntax error parsing expected css: ".concat(reason, " on line: ").concat(line)
    }].concat(args));
  }

  var parsedRules = ast.rules[0].declarations.filter(function (d) {
    return d.type === 'declaration';
  }).reduce(function (obj, _ref) {
    var property = _ref.property,
        value = _ref.value;
    return Object.assign(obj, _defineProperty({}, property, value));
  }, {});
  return parsedRules;
}

function display(context, value) {
  return typeof value === 'string' ? value : context.utils.stringify(value);
}

function getMessage(context, matcher, expectedLabel, expectedValue, receivedLabel, receivedValue) {
  return ["".concat(matcher, "\n"), // eslint-disable-next-line @babel/new-cap
  "".concat(expectedLabel, ":\n").concat(context.utils.EXPECTED_COLOR((0, _redent.default)(display(context, expectedValue), 2))), // eslint-disable-next-line @babel/new-cap
  "".concat(receivedLabel, ":\n").concat(context.utils.RECEIVED_COLOR((0, _redent.default)(display(context, receivedValue), 2)))].join('\n');
}

function matches(textToMatch, matcher) {
  if (matcher instanceof RegExp) {
    return matcher.test(textToMatch);
  } else {
    return textToMatch.includes(String(matcher));
  }
}

function deprecate(name, replacementText) {
  // Notify user that they are using deprecated functionality.
  // eslint-disable-next-line no-console
  console.warn("Warning: ".concat(name, " has been deprecated and will be removed in future updates."), replacementText);
}

function normalize(text) {
  return text.replace(/\s+/g, ' ').trim();
}

function getTag(element) {
  return element.tagName && element.tagName.toLowerCase();
}

function getSelectValue(_ref2) {
  var multiple = _ref2.multiple,
      options = _ref2.options;

  var selectedOptions = _toConsumableArray(options).filter(function (option) {
    return option.selected;
  });

  if (multiple) {
    return _toConsumableArray(selectedOptions).map(function (opt) {
      return opt.value;
    });
  }
  /* istanbul ignore if */


  if (selectedOptions.length === 0) {
    return undefined; // Couldn't make this happen, but just in case
  }

  return selectedOptions[0].value;
}

function getInputValue(inputElement) {
  switch (inputElement.type) {
    case 'number':
      return inputElement.value === '' ? null : Number(inputElement.value);

    case 'checkbox':
      return inputElement.checked;

    default:
      return inputElement.value;
  }
}

function getSingleElementValue(element) {
  /* istanbul ignore if */
  if (!element) {
    return undefined;
  }

  switch (element.tagName.toLowerCase()) {
    case 'input':
      return getInputValue(element);

    case 'select':
      return getSelectValue(element);

    default:
      return element.value;
  }
}

function compareArraysAsSet(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) {
    return (0, _isEqual.default)(new Set(a), new Set(b));
  }

  return undefined;
}

function toSentence(array) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$wordConnector = _ref3.wordConnector,
      wordConnector = _ref3$wordConnector === void 0 ? ', ' : _ref3$wordConnector,
      _ref3$lastWordConnect = _ref3.lastWordConnector,
      lastWordConnector = _ref3$lastWordConnect === void 0 ? ' and ' : _ref3$lastWordConnect;

  return [array.slice(0, -1).join(wordConnector), array[array.length - 1]].join(array.length > 1 ? lastWordConnector : '');
}